<div class="bmc-package-breadcrumb bz-color-border--neutral-300 bz-space--inset-s bz-space--stack-m">
    <div class="bmc-package-breadcrumb__path bz-space--inline-s" *ngFor="let path of pathList; let i = index" (click)="pathNavigation(path.catalogObjectId)">
        <span class="bz-space--inline-s"
            [ngClass]="{'bz-font-weight--semibold': ((i + 1) < pathList.length)}">
            {{ path.displayName | translate }}
        </span>
        <bzg-icon [nameIcon]="'icon-arrow-right-bold'" [color]="'success'" class="bz-space--inline-xs" [size]="12">
        </bzg-icon>
    </div>
</div>